var _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGoogleStrokeDark = function SvgGoogleStrokeDark(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "39.000000pt",
    height: "39.000000pt",
    viewBox: "0 0 39.000000 39.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,39.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101 368 c-137 -67 -136 -280 1 -347 51 -24 132 -28 181 -7 70 29 113 105 105 187 l-3 34 -95 0 -95 0 0 -40 0 -40 53 -5 c52 -5 52 -5 37 -27 -35 -49 -134 -47 -175 4 -27 35 -27 101 0 136 33 42 109 54 148 24 17 -13 78 45 67 63 -26 42 -154 53 -224 18z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoogleStrokeDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google-stroke-dark.26c77894.svg";
export { ForwardRef as ReactComponent };